<ng-select
  appendTo="body"
  [loading]="loading"
  [items]="itemsBuffer"
  [typeahead]="itemInput$"
  [searchFn]="searchFn"
  [closeOnSelect]="false"
  [trackByFn]="trackByFn"
  (close)="resetSelectedItems()"
  [(ngModel)]="selectedItems"
  [ngModelOptions]="{ standalone: true }"
  [disabled]="disabled"
  placeholder="Add multiple items..."
  (scroll)="onScroll($event)"
  (scrollToEnd)="onScrollToEnd()"
  class="line-items-multiselect"
>
  <ng-template ng-label-tmp let-item="item">
    <span *ngIf="item && item.id > 0">
      {{ item.product_name }} [{{ item.sku ? item.sku : 'N/A' }}]
    </span>
    <span *ngIf="item && item.id == 0">{{ item.product_name }}</span>
  </ng-template>
  <ng-template
    ng-option-tmp
    let-item="item"
    let-index="index"
    let-search="searchTerm"
  >
    <div (click)="onItemsSelect(item)" class="position-relative">
      <div
        class="d-flex justify-content-end selected-badge"
        *ngIf="selectedIds.includes(item.id)"
      >
        <span class="badge badge-success text-sm"> ADDED </span>
      </div>
      <div *ngIf="item && item.id">
        <div class="row">
          <div class="col-md-1" *ngIf="showImage">
            <img
              [src]="
                item.photo || (item.images?.length && item.images[0].thumbnail_url)
              "
              (error)="changeImageSourceOnError($event)"
            />
          </div>
          <div class="col-md modified text-wrap">
            <span *ngIf="item && item.id > 0">
              <p>{{ item.product_name }} [{{ item.sku ? item.sku : 'N/A' }}]</p>
            </span>
            <span *ngIf="item && item.id == 0"
              ><p>{{ item.product_name }}</p>
            </span>

            <div class="item-details mt-2 mb-1">
              <span
                *ngIf="showDescription && item.product_description"
                class="mr-1 d-inline-block"
                [innerHTML]="
                  item.product_description.length > 300
                    ? (item.product_description | slice: 0 : 300) + '..'
                    : item.product_description
                "
              >
              </span>
              <span *ngIf="item.is_discontinued == 1">
                <b class="text-warning">DISCONTINUED</b>
              </span>
              <span *ngIf="item.is_kit && item.is_kit == 1">
                <b class="text-info">KIT</b>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-select>
